import { SupplierOrigin } from '../../interfaces/Supplier/Supplier'
import { SupplierOriginAction } from '../actions/SupplierOriginActions'
import { supplierOriginActionsTypes } from '../types/supplierOriginActionsTypes'

export interface SuppliersOriginState {
  suppliersOriginState: {
    suppliersOrigin?: SupplierOrigin[] | undefined
    error?: string | undefined
  }
}

const initialState: SuppliersOriginState = {
  suppliersOriginState: { suppliersOrigin: [], error: '' }
}

export const suppliersOriginReducer = (
  state: SuppliersOriginState = initialState,
  action: SupplierOriginAction
): SuppliersOriginState => {
  if (action.type === supplierOriginActionsTypes.GET_SUPPLIERS_ORIGIN_EXITO) {
    return {
      ...state,
      suppliersOriginState: {
        suppliersOrigin: action.suppliersOrigin,
        error: action.error
      }
    }
  }
  return state
}
